module.exports = __webpack_public_path__ + "static/media/chevron-right.9e377a2e.svg";